
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.929 3.946h18.142V.929H.929v3.017zm0 14.796h18.142H.929zM.465 0A.465.465 0 000 .465v18.742c0 .256.208.464.465.464h19.07a.465.465 0 00.465-.464V.465A.465.465 0 0019.536 0H.465z","fill":"#4E6492"}}),_c('path',{attrs:{"d":"M12.497 2.713h3.617a.308.308 0 100-.616h-3.617a.308.308 0 100 .616M17.1 2.713h.658a.308.308 0 100-.616h-.657a.308.308 0 100 .616M3.574 2.415a.82.82 0 11-1.64 0 .82.82 0 011.64 0M6.033 2.415a.82.82 0 11-1.64 0 .82.82 0 011.64 0M8.493 2.415a.82.82 0 11-1.641 0 .82.82 0 011.64 0","fill":"#4E6492"}}),_c('path',{attrs:{"d":"M5.948 12.32L6.426 10h.94l-.93 3.643h-.815l-.69-2.293-.69 2.293h-.812L2.5 10h.94l.474 2.316L4.581 10h.704l.663 2.32zm5.067 0l.478-2.32h.94l-.93 3.643h-.814l-.69-2.293-.69 2.293h-.812L7.567 10h.94l.474 2.316L9.648 10h.704l.663 2.32zm5.067 0l.479-2.32h.939l-.93 3.643h-.814l-.69-2.293-.69 2.293h-.812L12.634 10h.94l.475 2.316.666-2.316h.704l.663 2.32z","fill":"#FFF"}})])])
          )
        }
      }
    